export default __webpack_public_path__ + "static/media/logo-dark2x.cbb0b695.png";